import {
  _setAllSsaStudents,
  _setNonCompliantOnly,
  _setSelectedSsaStudent,
  _setSelectedStudentsList,
  _setSelectedMultipleStudents,
  _setSelectedSsaStudentDetails,
  _setSelectedStudentHeadingDetails,
} from './ssaStudentDetailAction';
import { createSlice } from '@reduxjs/toolkit';
import initialState from './ssaStudentDetailInitialState';

export const ssaStudentDetailSlice = createSlice({
  name: 'delta/SSAStudentDetail',
  initialState: initialState,
  reducers: {
    setAllSsaStudents: _setAllSsaStudents,
    setNonCompliantOnly: _setNonCompliantOnly,
    setSelectedSsaStudent: _setSelectedSsaStudent,
    setSelectedStudentsList: _setSelectedStudentsList,
    setSelectedMultipleStudents: _setSelectedMultipleStudents,
    setSelectedSsaStudentDetails: _setSelectedSsaStudentDetails,
    setSelectedStudentHeadingDetails: _setSelectedStudentHeadingDetails,
  },
});

export const {
  setAllSsaStudents,
  setNonCompliantOnly,
  setSelectedSsaStudent,
  setSelectedStudentsList,
  setSelectedMultipleStudents,
  setSelectedSsaStudentDetails,
  setSelectedStudentHeadingDetails,
} = ssaStudentDetailSlice.actions;

export default ssaStudentDetailSlice.reducer;
